import { IPlanContent, MarkdownItem } from '../typings';
import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import { PlanKeyDetailsModal } from './common/PlanKeyDetailsModal';
import {
  businessDualKeyDetailsAddons,
  defaultBusinessGasDetailsAddons,
  defaultEstimatesDialog,
  defaultKeyDetails,
} from './common/planDefaults';

const defaultKeyFeatures: (string | MarkdownItem)[] = [
  {
    isMarkDown: true,
    content: 'Rates - Variable',
    modalContent: PlanKeyDetailsModal,
    modalTitle: 'Rates - Variable',
  },
  'No Exit fees',
  'Benefit period - 12 months, No lock ins',
];

export const originBusinessFCAAdvantageVariable: IPlanContent = {
  test: createPlanNameMatcher(['Origin Business FCA Advantage Variable']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on a 12 month benefit period',
      },
    },
    keyFeatures: {
      defaultState: {
        defaultFuel: defaultKeyFeatures,
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: defaultKeyDetails,
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: businessDualKeyDetailsAddons,
        gas: defaultBusinessGasDetailsAddons,
        electricity: [],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'grey',
              odsCore: 'neutral',
            },
            promobox: {
              styleGuide: 'blue',
              odsCore: 'neutral',
            },
            bannerText: {
              styleGuide: 'grey56',
              odsCore: 'neutralDark',
            },
          },
        },
      },
    },
    estimatesDialog: defaultEstimatesDialog(),
  },
};
